<p-avatar
    icon="pi pi-user"
    styleClass="p-mr-2"
    [style]="{'background-color':'#2196F3', 'color': '#ffffff'}"
    shape="circle" >
</p-avatar>